// The editable text of a document (doc_documents.content) — its shape and the
// defaults a new document starts from. SQL stores it as an opaque jsonb object;
// this file owns the shape. Wording follows the handoff templates
// (docs/docgen-handoff/templates): calm, factual, no exclamation marks.

export const CURRENCY_AR = { SAR: 'ريال', USD: 'دولار' };

// Terms rows. `text` rows are free; `deposit` and `validity` are computed from
// the document at render time, so they can never disagree with the prices or
// the valid-until date above them.
export const TERM_KINDS = ['text', 'deposit', 'validity'];

export function defaultQuotationContent() {
  return {
    clientName: '',
    photoSize: 'large',              // large | medium | small — gallery and thumbnails
    subject: '',
    scopeTitle: 'نطاق التوريد',
    scopeIntro: '',
    scopeBadge: '',
    scopeRows: [],                   // [{ label, details }]
    itemizedIntro: '',               // itemized layout: sentence above the section tables
    pricingTitle: 'التسعير',
    unitLabel: 'سعر الوحدة',         // "سعر الملعب" in the squash quotes
    perUnitLabel: 'الإجمالي للوحدة', // itemized section header, "الإجمالي للملعب"
    summaryTitle: 'ملخص التسعير',
    summaryItem: '',                 // itemized summary row description
    totalLabel: '',                  // '' → built from incoterm + port
    showVat: true,
    vatText: 'الأسعار غير شاملة ضريبة القيمة المضافة.',
    galleryTitle: '',
    includes: [],
    excludes: [],
    terms: [
      { kind: 'text', label: 'شروط الدفع', value: '50% دفعة مقدمة عند تأكيد الطلب، و50% قبل الشحن' },
      { kind: 'text', label: 'مدة الإنتاج', value: '' },
      { kind: 'deposit', label: 'الدفعة المقدمة' },
      { kind: 'validity', label: 'صلاحية العرض' },
    ],
    notice: { title: '', body: '' }, // highlighted box, e.g. a bank-holiday deadline
    note: { title: 'ملاحظة', body: '' },
  };
}

export function defaultRfqContent() {
  return {
    title: 'Order Request — Request for Quotation',
    photoSize: 'large',
    galleryTitle: 'Reference images',
    arSubtitle: '',
    scopeText: '',
    instructions: [
      'Complete the bronze columns for every item you can supply: unit price and total in USD, availability (write In stock or production lead time in days), and remarks.',
      'If the stated brand is not available, quote an equivalent and name the proposed brand/model in Remarks.',
      'Complete the Commercial Terms table on the last page in full.',
      'Partial quotations are accepted — leave blank any item you cannot supply.',
    ],
    termsRows: [
      { label: 'Grand Total (USD)', hint: 'Sum of all quoted items' },
      { label: 'Price Term (Incoterm)', hint: 'EXW / FOB — state port or city' },
      { label: 'Payment Terms', hint: 'e.g. 50% deposit, 50% before shipment (T/T)' },
      { label: 'Overall Lead Time', hint: 'Days after deposit, all items ready for shipment' },
      { label: 'Quotation Validity', hint: 'Days from quotation date' },
      { label: 'Packing', hint: 'Export packing description' },
      { label: 'Total Gross Weight (kg)', hint: 'Full order, packed' },
      { label: 'Total Volume (CBM)', hint: 'Full order, packed' },
      { label: 'Company Name & Contact', hint: 'Legal name, contact person, phone / WeChat' },
    ],
  };
}

// Stored content merged over the defaults, so a document saved before a new
// field existed still renders.
export function withDefaults(kind, content) {
  const base = kind === 'rfq' ? defaultRfqContent() : defaultQuotationContent();
  return { ...base, ...(content || {}) };
}
